<template>
	<div class="content">
		<div class="content-box">
			<div class="header">
				<div class="left"></div>
				<div class="title">九蛙工具箱</div>
				<div class="right">
					<div class="icon-menu">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</div>
			<div class="main">
				<div class="tit">九蛙工具箱</div>
				<div class="tip">每天都有成百上千的网友都在使用九蛙工具箱，为大家提供简单、有趣、好用的在线工具大全</div>
			</div>
		</div>
		<div class="page-inner">
			<div class="label-form">
				<label class="label-wrap must">
					<div class="label-name">url/paths (required)"</div>
					<input type="text" class="label-input" v-model="ruleForm.paths">
				</label>

				<label class="label-wrap must">
					<div class="label-name">utm_source (required)</div>
					<input type="text" class="label-input" v-model="ruleForm.utm_source">
				</label>
				<label class="label-wrap must">
					<div class="label-name">utm_medium (required)</div>
					<input type="text" class="label-input" v-model="ruleForm.utm_medium">
				</label>
				<label class="label-wrap must">
					<div class="label-name">utm_campaign (required)</div>
					<input type="text" class="label-input" v-model="ruleForm.utm_campaign">
				</label>
				<label class="label-wrap">
					<div class="label-name">utm_term (optional)</div>
					<input type="text" class="label-input" v-model="ruleForm.utm_term">
				</label>

				<label class="label-wrap">
					<div class="label-name">utm_content (optional)</div>
					<input type="text" class="label-input" v-model="ruleForm.utm_content">
				</label>
			</div>

			<div class="result-bar">
				<div class="tit">Automatically generated URL（上面填写完成后，下面自动生成标准UTM带参网址，可以复制直接使用）</div>

				<div class="input-wrap">
					<textarea class="textarea" id="success_form_input" readonly="readonly" v-model="resetUrl" rows="3" />
				</div>
				<button class="submit" ref="copy" data-clipboard-action="copy" data-clipboard-target="#success_form_input"
					@click="handlerCopy">复制</button>
			</div>

		</div>
	</div>
</template>

<script>
	import clipboard from 'clipboard';

	export default {
		computed: {
			resetUrl() {
				var {
					paths,
					utm_source,
					utm_medium,
					utm_campaign,
					utm_term,
					utm_content
				} = this.ruleForm
				if (paths && utm_source) {
					let pathArr = [paths],
						paramStr = "?",
						resetUrl = ""


					if (~paths.indexOf('?')) {
						pathArr = paths.split('?')
						paramStr = pathArr[1] || '?'
					}
					paramStr += `utm_source=${utm_source}`

					if (utm_medium) {
						paramStr += `&utm_medium=${utm_medium}`
					}
					if (utm_campaign) {
						paramStr += `&utm_campaign=${utm_campaign}`
					}
					if (utm_term) {
						paramStr += `&utm_term=${utm_term}`
					}
					if (utm_content) {
						paramStr += `&utm_content=${utm_content}`
					}

					return encodeURI(pathArr[0] + paramStr)
				} else {
					return ''
				}
			}
		},
		data() {
			return {
				copyBtn: null, //存储初始化复制按钮事件
				ruleForm: {
					paths: '',
					utm_source: '',
					utm_medium: '',
					utm_campaign: '',
					utm_term: '',
					utm_content: '',
				},
				rules: {
					paths: [{
						required: true,
						message: '请输入paths',
						trigger: 'blur'
					}],
					utm_source: [{
						required: true,
						message: '请输入utm_source',
						trigger: 'blur'
					}],
					utm_medium: [{
						required: true,
						message: '请输入utm_medium',
						trigger: 'blur'
					}],
					utm_campaign: [{
						required: true,
						message: '请输入utm_campaign',
						trigger: 'blur'
					}],
				}
			};
		},
		methods: {
			handlerCopy() {
				let _this = this;
				let clipboard = _this.copyBtn;
				clipboard.on('success', function() {
					// _this.$message({
					// 	/*这是使用了element-UI的信息弹框*/
					// 	message: '复制成功！',
					// 	type: 'success'
					// });
					alert("复制成功")
				});
				clipboard.on('error', function() {
					// _this.$message({
					// 	message: '复制失败，请手动选择复制！',
					// 	type: 'error'
					// });
					alert("复制失败，请手动选择复制！")
				});
			},
		},
		// 必须要在onReady生命周期，因为onLoad生命周期组件可能尚未创建完毕
		mounted() {
			this.copyBtn = new clipboard(this.$refs.copy);
		}
	};
</script>

<style lang="scss">
	.icon-menu {
		width: 20px;
		height: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;

		span {
			display: block;
			width: 100%;
			height: 2px;
			border-radius: 1px;
			background-color: #fff;
		}
	}

	.label-form {
		padding: 20px 15px;
		box-sizing: border-box;
	}

	.label-wrap {
		position: relative;
		display: flex;
		margin-bottom: 15px;

		&.must::after {
			position: absolute;
			left: -10px;
			top: 0;
			content: "*";
			color: red;
		}

		.label-name {
			width: 120px;
			min-width: 120px;
		}

		.label-input {
			font-size: 15px;
			width: calc(100% - 120px);
			padding: 0 10px;
			border: 1px solid #d5d5d5;
			border-radius: 3px;
			outline: none;
		}
	}

	.content-box {
		color: #fff;
		background-image: url(../../static/5b48ac31100b0.jpg);
		background-size: 100%;

		.header {
			position: relative;
			height: 50px;
			line-height: 50px;
			border-bottom: 1px solid rgba(255, 255, 255, .2);
			padding: 0 15px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.title {
				font-size: 22px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				max-width: 240px;
				line-height: 32px;
				height: 32px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.right {
				width: 30px;
				height: 30px;
				border: 1px solid #fff;
				border-radius: 3px;
				background-color: rgba(255, 255, 255, .2);
				display: flex;
				align-items: center;
				justify-content: center;
				float: right;
				box-sizing: border-box;
			}
		}

		.main {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 40px 30px;
			text-align: center;

			.tit {
				line-height: 30px;
				font-size: 24px;
				margin-bottom: 20px;
			}
		}
	}

	.form-bar {
		padding: 0 15px;

		>>>.u-form-item--left__content__label {
			line-height: 40px;
		}
	}

	.page-inner {
		border-top: 8px solid #f5f5f5;
	}

	.result-bar {
		padding: 20px 15px;

		.tit {
			line-height: 20px;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 20px;
		}

		.input-wrap {
			margin-bottom: 20px;

			.textarea {
				padding: 10px;
				width: 100%;
				border: 1px solid #d5d5d5;
				border-radius: 3px;
				resize: none;
				box-sizing: border-box;
				outline: none;
			}
		}

		.submit {
			width: 100%;
			border-radius: 5px;
			font-size: 15px;
			height: 40px;
			line-height: 40px;
			color: #ffffff;
			border: none;
			background-color: #2979ff;
			cursor: pointer;
			padding: 0 20px;
			z-index: 1;
			box-sizing: border-box;
		}
	}
</style>
